if (!window.Maximize.loadedScript.includes('sticky-atc.js')) {
  window.Maximize.loadedScript.push('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('stickyATC', {
        isOpen: false,
        isFooterShow: false,
        isProductInfoOutOfView: false,
        isOpenDetailOnMobile: false,
        handleInit(sectionId) {
          this.scrollY = window.scrollY;
          // BetaTech (2026-10-20, client request): the bar appears as soon as the main add-to-cart
          // button has scrolled out of view (above the screen, or under the sticky header) and hides
          // again when it is visible. The theme waited until the whole product info column had left the
          // screen. Without a main button (e.g. "hide cart"), the theme's rule below still applies.
          const betaBuyButton = document.querySelector(`.section--${sectionId} .product-info__buy-buttons-wrapper .product-form__btn-add-to-cart`);
          if (betaBuyButton) {
            this.betaObserveBuyButton(betaBuyButton);
            return;
          }
          let contentWrapperEle = document.querySelector(`.section--${sectionId} .product-template__content-wrapper`);
          let mediaWrapperEle = document.querySelector(`.section--${sectionId} .product-template__media-wrapper`);
          let productDetailsEle = document.querySelector(`.section-main-product + .section-product-details product-details`);
          const footerElement = document.getElementById("x-footer");
          const sectionElements = document.querySelectorAll(".x-bundle-section");
          let isAnySectionVisible = false;

          const observer = new IntersectionObserver(
            (entries) => {
              isAnySectionVisible = false;
              
              entries.forEach((entry) => {
                if (entry.target.classList.contains('x-bundle-section') && window.innerWidth < 1023) {
                  if (entry.isIntersecting) {
                    isAnySectionVisible = true;
                  }
                }
                else if (entry.target === contentWrapperEle || entry.target === mediaWrapperEle || entry.target === productDetailsEle) {
                  const contentBottom = contentWrapperEle?.getBoundingClientRect().bottom ?? 0;
                  const mediaAndDetailsEl = productDetailsEle || mediaWrapperEle;
                  const mediaAndDetailsBottom = mediaAndDetailsEl?.getBoundingClientRect().bottom ?? 0;

                  if (contentBottom <= mediaAndDetailsBottom && entry.target === mediaAndDetailsEl) {
                    this.isProductInfoOutOfView = !entry.isIntersecting && (mediaAndDetailsBottom < window.innerHeight);
                  } else if (contentBottom > mediaAndDetailsBottom && entry.target === contentWrapperEle) {
                    this.isProductInfoOutOfView = !entry.isIntersecting && (contentBottom < window.innerHeight);
                  }
                } else if (entry.target.id === "x-footer") {
                  this.isFooterShow = entry.isIntersecting;
                }
              });
              this.isOpen = !this.isFooterShow && this.isProductInfoOutOfView && !isAnySectionVisible;
            },
            {root: null, threshold: 0, rootMargin: "0px 0px -10px 0px"}
          );

          if (footerElement) {
            observer.observe(footerElement);
          }
          if (productDetailsEle) {
            observer.observe(productDetailsEle);
          } else if (mediaWrapperEle) {
            observer.observe(mediaWrapperEle);
          }
          sectionElements.forEach(el => {
            if (el) observer.observe(el);
          });
          
          observer.observe(contentWrapperEle);
        },
        // BetaTech (2026-10-20): isProductInfoOutOfView = the main button is entirely above the visible
        // area (the screen minus what is stuck at the top: the sticky header and, when Announcement bar →
        // "Sticky bar" is on, the announcement bar, above or below the header). Below the screen (not
        // reached yet) does not count. The footer and the product bundle sections (phones) still hide the
        // bar, as in the theme. Those heights change with the breakpoint, so the observer is rebuilt after
        // a resize (and once after load, when fonts and images have settled).
        betaObserveBuyButton(buyButton) {
          const footerElement = document.getElementById("x-footer");
          const bundleSections = document.querySelectorAll(".x-bundle-section");
          const visibleBundles = new Set();
          const update = () => {
            this.isOpen = !this.isFooterShow && this.isProductInfoOutOfView && visibleBundles.size === 0;
          };

          const pageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.target === footerElement) {
                this.isFooterShow = entry.isIntersecting;
              } else if (entry.isIntersecting && window.innerWidth < 1023) {
                visibleBundles.add(entry.target);
              } else {
                visibleBundles.delete(entry.target);
              }
            });
            update();
          }, {root: null, threshold: 0});
          if (footerElement) pageObserver.observe(footerElement);
          bundleSections.forEach((el) => pageObserver.observe(el));

          // theme.css stacks them: the header at top: var(--announcement-height) under a sticky bar, or a
          // sticky bar at top: var(--height-header) under the header; a non-sticky one adds nothing.
          const stuckTopHeight = () => {
            let height = 0;
            document.querySelectorAll(".shopify-section.section-header, .shopify-section.section-announcement").forEach((element) => {
              const position = getComputedStyle(element).position;
              if (position === "sticky" || position === "fixed") height += element.getBoundingClientRect().height;
            });
            return Math.max(0, Math.round(height));
          };

          let buttonObserver = null;
          const observeButton = () => {
            if (buttonObserver) buttonObserver.disconnect();
            const top = stuckTopHeight();
            buttonObserver = new IntersectionObserver((entries) => {
              const entry = entries[entries.length - 1];
              const visibleTop = entry.rootBounds ? entry.rootBounds.top : top;
              this.isProductInfoOutOfView = !entry.isIntersecting
                && entry.boundingClientRect.height > 0
                && entry.boundingClientRect.bottom <= visibleTop + 1;
              update();
            }, {root: null, threshold: 0, rootMargin: `-${top}px 0px 0px 0px`});
            buttonObserver.observe(buyButton);
          };
          observeButton();
          if (document.readyState !== "complete") window.addEventListener("load", observeButton, {once: true});

          let resizeTimer;
          window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(observeButton, 150);
          });
        }
      })

      Alpine.data('xStickyATC', (stickyATCContainerEl, sectionId) => ({
        isOpenDetailOnMobile: false,
        isFirstLoading: true,
        isMobile: window.innerWidth < MIN_DEVICE_WIDTH.desktop,
        availableOptions: [],
        variantOptionsEle: [],
        options: [],
        optionsSelectedValues: [],
        init() {
          this.optionElements = this.$el.querySelectorAll(`#StickyAddToCart__Variant__${sectionId} .variant-option`)
          this.optionsSelectedValues = this.updateOptionSelectedValues();

          const isMobile = window.matchMedia(`(max-width: ${MIN_DEVICE_WIDTH.desktop - 1}px`);

          const handleMediaChange = (e) => {
            if (e.matches) {
              this.isMobile = true;
              if (!this.isFirstLoading) Alpine.store("stickyATC").isOpenDetailOnMobile = true;
            } else {
              this.isMobile = false;
              Alpine.store("stickyATC").isOpenDetailOnMobile = false;
            }
          };

          handleMediaChange(isMobile);
          isMobile.addEventListener('change', handleMediaChange);
          this.isFirstLoading = false;
        },
        selectOptionSticky(event) {
          const targetOption = event.currentTarget;
          let position = targetOption.dataset.optionPosition;

          this.optionsSelectedValues[Number(position) - 1] = targetOption.dataset.optionValueId;

          document.dispatchEvent(new CustomEvent(`${STICKY_ATC_EVENT.optionChange}-${sectionId}`, {
            detail: {
              optionsSelectedValues: this.optionsSelectedValues
            }
          }));
        },
        updateOptionSelectedValues() {
          const newOptionsSelectedValues = [];

          this.optionElements.forEach((optionEle) => {
            const optionPosition = optionEle.dataset.optionPosition;
            const idx = Number(optionPosition) - 1;
            if (optionEle.classList.contains('selected')) {
              newOptionsSelectedValues[idx] = optionEle.dataset.optionValueId;
            }
          });

          return newOptionsSelectedValues;
        }
      }))
    })
  })
}
